import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { QuickQuestion } from '../../../domain/models/quick-question.model';

@Component({
  selector: 'talk-to-your-data-quick-question-list',
  templateUrl: './quick-question-list.component.html',
  styleUrls: ['./quick-question-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickQuestionListComponent {
  @Input() quickQuestions: readonly QuickQuestion[] | null = [];
  @Output() readonly questionSelected = new EventEmitter<QuickQuestion>();

  onQuestionSelected(question: QuickQuestion): void {
    if (!question?.prompt) {
      return;
    }

    this.questionSelected.emit(question);
  }

  trackByQuestionId = (index: number, question: QuickQuestion): string => question.id || String(index);
}
